import React from 'react'
import './Team.css'
import Button from '../button/Button'
import { useNavigate } from 'react-router-dom';

function Team({buttonText, className}) {

  const navigate = useNavigate(); // Access navigate function

  const onButtonClick = () => {
    navigate('/contact'); // Redirect to '/contact' route
  };
  return (
    <div className='team'>
        <div className='teamText'>
            <div className='teamTitle'>Make an impact with Team Impact</div>
            <Button onClick={onButtonClick} buttonText={buttonText} className={className} arrowClassName="custom-arrow" />
        </div>  
    </div>
  )
}

export default Team
